<template>
	<div class="home-view">
		<!-- <van-nav-bar title="标题" left-arrow /> -->
		<!-- 直播内容 -->
		<div class="live-content">
			<!-- 直播背景 -->
			<!-- <div v-if="liveinfo.live_status == 1" class="live-background">
				<img :src="liveinfo.cover != '' && liveinfo.cover != null ? liveinfo.cover : liveinfo.default.cover" alt="" />
			</div> -->
			<!-- <div v-if="(liveinfo.live_status == 2 || (liveinfo.playback_status == 1 && liveinfo.live_status == 3)) && isplay == false" class="live-background">
				<img :src="liveinfo.cover != '' && liveinfo.cover != null ? liveinfo.cover : liveinfo.default.cover" alt="" />
			</div> -->
			<!-- 播放按钮 -->
			<!-- <div
				v-if="(liveinfo.live_status == 2 || (liveinfo.playback_status == 1 && liveinfo.live_status == 3)) && isplay == false"
				class="play-icon"
				@click="testLive"
			></div> -->
			<!-- 直播已结束 -->
			<div class="background" v-if="(liveinfo.playback_status != 1 && liveinfo.live_status == 3)"></div>
			<div v-if="liveinfo.playback_status != 1 && liveinfo.live_status == 3" class="live-end">
				<div class="end-icon">直播已结束</div>
			</div>
			<div class="bofore-live" v-if="liveinfo.live_status == 1 || (liveinfo.playback_status != 1 && liveinfo.live_status == 3)">
				<img
					class="image"
					fit="contain"
					:src="liveinfo.guide_cover ? liveinfo.guide_cover : liveinfo.cover"
					alt=""
				 />
			</div>
			<!-- 直播进行中 且强制签到和直播密码 -->
			<!-- <div class="bofore-live" v-if="liveinfo.live_status == 2 && liveinfo.is_real && liveinfo.encryption_status == 2">
				<img
					class="image"
					fit="contain"
					:src="liveinfo.guide_cover ? liveinfo.guide_cover : liveinfo.cover"
					alt=""
				 />
			</div> -->
			<!-- 直播界面 -->
			<!-- <div v-if="(liveinfo.live_status == 2 && (!liveinfo.is_real || liveinfo.encryption_status == 1)) || (liveinfo.playback_status == 1 && liveinfo.live_status == 3)" class="play-video"></div> -->
			<div v-if="liveinfo.live_status == 2 || (liveinfo.playback_status == 1 && liveinfo.live_status == 3)" class="play-video">
				<!-- <div class="home" @click="jump('https://wechat.kopen.com.cn/html/vrbuild/#/liver')" v-if="!isApp">
					<van-icon name="wap-home-o" color="#fff" size="22" />
				</div> -->
				<div class="refresh" @click="refreshPage">
					<van-icon name="replay" color="#fff" size="22" />
				</div>
				<!-- <div class="viewer">
					<van-icon name="eye-o" color="#fff" />
					<span style="margin-left: 5px">{{ liveinfo.watch }}</span>
				</div> -->

				<div class="time-notice" v-if="timeNoticeShow">福袋即将开启，敬请期待！</div>
				<div class="lottery" @click="openLottery(true)" v-if="lotterytimeBagShow">
					<div class="lottery-content"></div>
					<div class="times">
						<van-count-down style="color: #fff; font-size: 8px" :time="lotterytime" @finish="openLottery" />
					</div>
				</div>

				<TcPlayer ref='playerVideo' :id="'testplayer'" :liveinfo="liveinfo" :url="pull_flow_url" :userinfo="userinfo" :cover="liveinfo.guide_cover" :iswater="iswater"></TcPlayer>
			</div>
			<!-- 倒计时 -->
			<div class="timeDown" v-if="liveinfo.live_status == 1 && time >= 0">
				<van-count-down :time="time" class="timer" @finish="liveStart">
					<template #default="timeData">
						<span>距开播：</span>
						<div class="time">{{ timeData.days }}</div>
						<span>天</span>
						<div class="time">{{ timeData.hours }}</div>
						<span>小时</span>
						<div class="time">{{ timeData.minutes }}</div>
						<span>分</span>
						<div class="time">{{ timeData.seconds }}</div>
						<span>秒</span>
					</template>
				</van-count-down>
				<!-- <div class="notice" @click="getNotice"><van-icon name="bell" color="#f5d11f" />订阅提醒</div> -->
			</div>
		</div>
		<!-- 直播标题介绍 -->
		<div class="live-desc">
			<div class="left">
				<div class="img-left" @click="getLicense">
					<img :src="liveinfo.avatar" alt="" />
				</div>
				<div class="desc-content">
					<div class="title" v-show="liveinfo.name">{{ liveinfo.name }}</div>
					<div class="desc" v-html="liveinfo.overview"></div>
				</div>
			</div>
			<div class="live-info">
				<img src="../assets/images/ic-visible.png" ></img>
				{{ liveinfo.watch}}
			</div>

			<!-- <div class="follow" @click="getAttention" v-if="userinfo != null && userinfo.attention == 2"><van-icon name="plus" />关注</div> -->
			<!-- <div
				class="follow"
				@click="cancelAttention"
				style="background-color: #ccc; color: #fff"
				v-if="userinfo != null && userinfo.attention == 1"
			>
				已关注
			</div> -->
		</div>
		<!-- tab栏 -->
		<div class="nav-tabs">
			<van-tabs 
				type="card" 
				style="width: 100%" 
				v-model="activeName" 
				@click="tabChange" 
				:ellipsis=false
			>
				<van-tab 
					v-for="item in menuList" 
					:key="item.id" 
					:name="item.name" 
					:title="item.show_name" 
					style="height: 100%"
				/>
				<!--v-if="tabName === '商品展示' || activeName === 'order_coucher'"-->
				<van-tab
					v-if="menuList && menuList.length > 0 && hasOrderRecord"
					name="order_coucher"
					title="订购凭证"
					style="width: 100%;"
				/>
			</van-tabs>
		</div>

		<!-- 内容 -->
		<div class="tab-content" >
			<!-- 嵌套链接 -->
			<div v-show="tabName === '内嵌链接'" ref="iframeContainer" id="iframeContainer"></div>
			<!-- 直播介绍 -->
			<div v-if="tabName === '直播介绍'" class="tab-live-desc">
				<div class="title">{{ liveinfo.name }}</div>
				<div
					class="live-des-detail"
					style="width: 100%"
					v-html="liveinfo.desc"
				></div>
			</div>
			<!--图文介绍循环div内容-->
			<div
				v-for="tabType in ['图文介绍一', '图文介绍二', '图文介绍三', '图文介绍四', '图文介绍五']"
				:key="tabType"
				v-if="tabName === tabType"
				class="tab-live-desc"
			>
				<div
					class="live-des-detail"
					style="width: 100%"
					v-html="getMenuContent(tabType)"
				></div>
			</div>
			<!-- 互动聊天 -->
			<!-- <div v-show="tabName === '互动评论'" class="chart"> -->
				<Chat v-show="tabName === '互动评论'"
					ref="chatref"
					:isRedShow.sync="isRedpacketShow"
					:muteState="isMute"
					:topMessage="topMessage"
					:likeextra="likenum"
					:redDetail="redDetail"
					:lotteryShow="chatLotteryShow"
					:inviteShow="inviteIconShow"
					:inviteShareShow="inviteShareShow"
					:redremainId="redremainId"
					:live_id="id"
					:user_id="userId"
					:liveinfo="liveinfo"
					:isApp="isApp"
					@watch="changeWatch"
					@get-red="checkRedremain"
					@unopen-red="unopen"
					@red-packet="processRed"
					@shutUp="shutUp"
					@unShutUp="unShutUp"
					@start-live="getLiveinfo(false)"
					@stop-live="getLiveinfo(false, true)"
					@invitation-card="openInviteCard"
					@entry-form="openApplyForm"
					@lottery="openPrice"
					@sign-in="openSign"
					@more-fun="openMore"
					@lottery-opened="openAll"
					@lottery-updated="updateLotteryList"
          @login="wxLogin"
				></Chat>
			<!-- </div> -->
			<!-- 商品展示 -->
			<div v-if="tabName === '商品展示'" class="buy-while-watch">
				<div class="good-item" @click="$router.push({ name: 'good', query: { id: item.id, isQuery: item.is_new==2?false:true , liveId: id, userId: userId } })"  v-for="(item, index) in goodsList" :key="item.id">
					<div class="good-img" v-if="item.price != null && item.price != ''" @click="openQuery(item)">
						<img :src="item.pic_list != null ? item.pic_list[0] : '/'" alt="" />
					</div>
					<div class="good-img" v-if="item.price == null || item.price == ''" @click="openQuery(item)">
						<img :src="item.pic_list != null ? item.pic_list[0] : '/'" alt="" />
					</div>
					<div class="good-detail">
						<div class="title" v-if="item.price != null && item.price != ''" @click="openQuery(item)">
							{{ item.name }}
						</div>
						<div class="title" v-if="item.price == null || item.price == ''" @click="openQuery(item)">
							{{ item.name }}
						</div>
						<!-- <div class="goodsno">{{item.product_no}}</div> -->
						<div class="goodsno" v-html="item.desc"></div>

						<div style="display: flex;">
							<div v-if="item.is_new == 1" class="detail-button" @click.stop="openQuery(item)">立即询价</div>
							<div 
								class="detail-button" 
								@click.stop="dingJin(item)"
								v-if="isInTimeRange(depositTimeConfig.start_time, depositTimeConfig.end_time)"
								:class="{ disabled: !isInTimeRange(depositTimeConfig.start_time, depositTimeConfig.end_time) }"
							>
								下定金
							</div>
							<div v-if="item.coupon_configs.length" class="detail-button" @click.stop="fntoweb(1,item)">抢优惠券</div>
							<div v-if="item.is_new == 1 && item.deposit_configs.length" class="detail-button" @click.stop="fntoweb(2,item)">支付定金</div>
							<div v-if="item.is_new == 2" class="detail-button" @click.stop="openTry(item)">预约试驾</div>
							<!-- <div
								class="detail-button"
								@click="$router.push({ name: 'good', query: { id: item.id, isQuery: item.is_new == 1?true:false, liveId: id, userId: userId } })"
							>
								了解详情
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<!-- 排行榜单 -->
			<div v-if="tabName === '邀请榜单'" class="invite-content">

				<div class="pop-click" v-if="rankList.length != 0">
					<span v-if="myRank.link_name !== null && myRank.link_name !== ''" style="color: #999;">已填写邀请榜收货地址</span>
					<span class="click-btn" v-else @click="inviteAddressForm">邀请榜收货地址填写</span>
				</div>
				<div class="content intab">
					<van-empty v-if="rankList.length == 0" description="暂无榜单数据" />
					<div v-if="rankList.length != 0" class="invite-item" v-for="(item, index) in rankList" :key="item.id">
						<div class="left">
							<div
								:class="{
									rank: true,
									first: index === 0 ? true : false,
									second: index === 1 ? true : false,
									third: index === 2 ? true : false,
								}"
							>
								{{ index !== 0 && index !== 1 && index !== 2 ? index + 1 : "" }}
							</div>
							<div class="img-left">
								<img :src="item?.user?.avatar" alt="" />
							</div>
							<span>{{ item?.user?.nick_name }}</span>
						</div>
						<div class="right">
							<span>邀请{{ item.invite_num }}人</span>
						</div>
					</div>
					<div v-show="isBottom == false && rankList.length != 0 && rankList.length > 10" class="see-more" style="color: blue" @click="getRankList(true)">
						查看更多榜单数据
					</div>
					<div v-show="isBottom == true && rankList.length != 0" class="see-more" style="color: #bbb">已经到底了</div>
					<div class="my-info">
						<div class="left">
							<div class="img-left">
								<img :src="userinfo != null ? userinfo.avatar : ''" alt="" />
							</div>
							<div class="desc-content">
								<div class="title">{{ userinfo != null ? userinfo.nick_name : "" }}</div>
								<div class="desc">
									<span v-if="myRank.invite_num == 0">暂未上榜</span
									><span v-else>排行{{ myRank.ranking }}名 已成功邀请{{ myRank.invite_num != null ? myRank.invite_num : 0 }}人</span>
								</div>
							</div>
						</div>

						<div class="follow" @click="inviteNow">立即邀请</div>
					</div>
				</div>
			</div>
			<!-- 添加客服 -->
			<div v-if="tabName === '引导关注'" class="content" style="display: flex; justify-content: center">
				<div class="qr-dialog intab">
					<div class="attractCode">
						<div style="margin-top: 30px; color: black; font-size: 18px; font-weight: bold">
							{{ liveinfo.service_desc != "" && liveinfo.service_desc != null ? liveinfo.service_desc : "长按识别客服二维码" }}
						</div>
						<!-- <span style="margin-top: 20px; color: black; font-size: 16px">{{ liveinfo.service_title }}</span> -->
						<div style="margin-top: 30px" class="qrcod">
							<img :src="liveinfo.service_qrcode" alt="" />
						</div>
						<a
							v-if="liveinfo.service_mobile != '' && liveinfo.service_mobile != null"
							style="margin-top: 20px; color: black; font-size: 16px; font-weight: bold"
							:href="'tel:' + liveinfo.service_mobile"
							>服务热线：{{ liveinfo.service_mobile }}</a
						>
					</div>
				</div>
			</div>
			<!-- 相关直播 -->
			<div v-if="tabName === '相关直播'" class="livercontent" >
				<liverlist :liverlistDate="liverlistDate" @fntoliver="fntoliver"></liverlist>
			</div>
			<!--订购凭证-->
			<div v-if="tabName === 'order_coucher'" class="order-list-content">
				<coucherlist 
					:userId='userId' 
					:live_id="id"
					:hasToPAyCount="hasToPAyCount"
					:orderList="orderList"
					@hasOrder="handleHasOrder"
				/>
			</div>
		</div>
		<!-- tab栏 -->
		<!-- 查看榜单 -->
		<van-popup class="invite-content" v-model="inviteListShow" position="bottom" round :style="{ height: '75%' }">
			<div class="content">
				<van-tabs type="line">
					<van-tab title="邀请排行榜">
						<van-empty v-if="rankList.length == 0" description="暂无榜单数据" />
						<div v-else class="invite-rank">
							<div class="invite-item" v-for="(item, index) in rankList" :key="item.id">
								<div class="left">
									<div
										:class="{
											rank: true,
											first: index === 0 ? true : false,
											second: index === 1 ? true : false,
											third: index === 2 ? true : false,
										}"
									>
										{{ index !== 0 && index !== 1 && index !== 2 ? index + 1 : "" }}
									</div>
									<div class="img-left">
										<img :src="item?.user?.avatar" alt="" />
									</div>
									<span>{{ item?.user?.nick_name }}</span>
								</div>
								<div class="right">
									<span
										>邀请<span style="font-weight: bold">{{ item.invite_num }}</span
										>人</span
									>
								</div>
							</div>
							<div v-show="isBottom == false && rankList.length >10" class="see-more" style="color: blue" @click="getRankList(true)">查看更多榜单数据</div>
							<div v-show="isBottom == true" class="see-more" style="color: #bbb">已经到底了</div>
						</div>
					</van-tab>
					<van-tab title="我的邀请">
						<van-empty v-if="myRankList.length == 0" description="暂无邀请数据" />
						<div v-else class="invite-rank">
							<div class="invite-item" v-for="(item, index) in myRankList" :key="item.id">
								<div class="left">
									<div class="rank">{{ index + 1 }}</div>
									<div class="img-left">
										<img :src="item?.user?.avatar" alt="" />
									</div>
									<span>{{ item?.user?.nick_name }}</span>
								</div>
								<div class="right">
									<span>{{ item.user.created_at }}</span>
								</div>
							</div>
						</div></van-tab
					>
				</van-tabs>
				<div class="my-info">
					<div class="left">
						<div class="img-left">
							<img :src="userinfo != null ? userinfo.avatar : ''" alt="" />
						</div>
						<div class="desc-content">
							<div class="title">{{ userinfo != null ? userinfo.nick_name : "" }}</div>
							<div class="desc">
								<span v-if="myRank.invite_num == 0">暂未上榜</span
								><span v-else>排行{{ myRank.ranking }}名 已成功邀请{{ myRank.invite_num != null ? myRank.invite_num : 0 }}人</span>
							</div>
						</div>
					</div>

					<div class="follow" @click="inviteNow">立即邀请</div>
				</div>
			</div>
		</van-popup>
		<!-- 更多功能 -->
		<van-popup class="more-function" closeable v-model="moreFunctionShow" position="bottom" round :style="{ height: '15%' }">
			<div class="more-content">
				<!-- <div class="more-content-item" @click="openRed">
					<div class="item-img">
						<img src="@/assets/images/hongbao.png" alt="" />
					</div>
					<div class="item-desc">发送红包</div>
				</div> -->
				<div class="more-content-item" @click="fnmyprize">
					<div class="item-img">
						<img src="@/assets/images/present.png" alt="" />
					</div>
					<div class="item-desc">我的奖品</div>
				</div>
				<!-- <div class="more-content-item" @click="jump('https://wechat.kopen.com.cn/inquiry')">
					<div class="item-img">
						<img src="@/assets/images/query.png" alt="" />
					</div>
					<div class="item-desc">在线询价</div>
				</div>
				<div class="more-content-item" @click="jump('https://wechat.kopen.com.cn/html/vrbuild/#/liver')">
					<div class="item-img">
						<img src="@/assets/images/home.png" alt="" />
					</div>
					<div class="item-desc">直播大厅</div>
				</div> -->
			</div>
		</van-popup>
		<!-- 红包领取 -->
		<van-dialog class="to-invite-dialog redpacket" :closeOnClickOverlay="true" v-model="redpacketShow" :show-confirm-button="false">
			<div class="red-packet">
				<div class="red-packet-bg"></div>
				<div class="red-packet-content">
					<div class="user-avatar">
						<img :src="redinfo.user.avatar" alt="" />
					</div>
					<div class="user-name">{{ redinfo.user.nick_name }}</div>
					<div class="user-name">发了一个红包请查收</div>
					<div class="pass-desc" style="margin-top: 45px; font-size: 22px" v-if="redinfo.redpacket.surplus_num == 0">该红包已被领完</div>
					<div
						class="pass-desc"
						style="margin-top: 185px; font-size: 14px; font-weight: normal"
						v-if="redinfo.redpacket.surplus_num == 0"
						@click="$router.push({ name: 'reddetail', query: { redId: redinfo.redpacket.id, liveId: id, userId: userId } })"
					>
						查看领取详情
					</div>
					<div class="pass-desc" v-if="redinfo.redpacket.surplus_num != 0 && redinfo.redpacket.type == 2">
						口令提示:{{
							redinfo.redpacket.password_desc != "" && redinfo.redpacket.password_desc != null
								? redinfo.redpacket.password_desc
								: "请输入红包口令"
						}}
					</div>
					<div class="pass-desc" v-if="redinfo.redpacket.surplus_num != 0 && redinfo.redpacket.type == 1">
						{{ redinfo.redpacket.title }}
					</div>
					<div class="pass-input" v-if="redinfo.redpacket.surplus_num != 0 && redinfo.redpacket.type == 2">
						<input
							type="text"
							v-model="redpass"
							style="text-align: center; border: none; outline: none; background-color: transparent; color: #fff"
						/>
					</div>
					<div class="red-open" @click="recieveRed" v-if="redinfo.redpacket.surplus_num != 0"></div>
				</div>
			</div>
			<div class="delButton" @click="redpacketShow = false"><van-icon name="cross" color="#aaa" /></div>
		</van-dialog>
		<!-- 红包领取成功 -->
		<van-dialog class="to-invite-dialog redpacket" :closeOnClickOverlay="true" v-model="recieveShow" :show-confirm-button="false">
			<div class="red-packet">
				<div class="recieve-bg"></div>
				<div class="red-packet-content">
					<div class="user-avatar">
						<img :src="redDetail.user.avatar" alt="" />
					</div>
					<div class="user-name" style="color: #000">{{ redDetail.user.nick_name }}</div>
					<div class="pass-desc" style="margin-top: 45px; font-size: 35px; color: #f94d31">
						￥{{ redDetail.receive_money }}<span style="margin-top: 45px; font-size: 14px; color: #f94d31">元</span>
					</div>
					<div
						class="pass-desc"
						style="margin-top: 59px; color: #000; font-weight: normal; font-size: 14px"
						@click="$router.push({ name: 'reddetail', query: { redId: redDetail.redpacket_id, liveId: id, userId: userId } })"
					>
						查看领取详情
					</div>
					<div class="pass-desc" style="margin-top: 58px; color: #fee393; font-size: 25px">恭喜您获得红包</div>
					<div class="pass-desc" style="margin-top: 28px; color: #fff; font-size: 14px">已通过的d1cm公众号</div>
					<div class="pass-desc" style="margin-top: 5px; color: #fff; font-size: 14px">发送至您的零钱</div>
				</div>
			</div>
			<div class="delButton" @click="recieveShow = false"><van-icon name="cross" color="#aaa" /></div>
		</van-dialog>
		<!-- 红包 -->
		<van-popup class="more-function" closeable v-model="redShow" position="bottom" round :style="{ height: '15%' }">
			<div class="more-conten-title">现金红包</div>
			<div class="more-content" style="justify-content: flex-start; padding-top: 10px">
				<div class="more-content-item" @click="$router.push({ name: 'redpacket', query: { isNormal: true, liveId: id, userId: userId } })">
					<div class="item-img">
						<img src="@/assets/images/hongbao.png" alt="" />
					</div>
					<div class="item-desc">普通红包</div>
				</div>
				<div
					v-if="userinfo.user_type != null && userinfo.user_type != 1"
					class="more-content-item"
					style="margin-left: 35px"
					@click="$router.push({ name: 'redpacket', query: { isNormal: false, liveId: id, userId: userId } })"
				>
					<div class="item-img" style="width: 56px; height: 43px">
						<img src="@/assets/images/hongbao-2.png" alt="" />
					</div>
					<div class="item-desc">口令红包</div>
				</div>
			</div>
		</van-popup>
		<!-- 预约试驾弹框 -->
		<askdriveform 
			:userId='userId' 
			:live_id="id"  
			:showTryform.sync="showTryform" 
			:goodsList="goodsList" 
			@closeshowTryform="closeTryform"
		/>
		<!-- 询价弹框 -->
		<askpriceform 
			:userId='userId' 
			:live_id="id"  
			:queryShow.sync="queryShow" 
			:goodDetail="goodDetail" 
			@closeshowpriceform='closepriceform'
		/>
		<!-- 报名表弹框 -->
		<applyform 
			:applyFormShow.sync="applyFormShow" 
			:applyForm='applyForm' 
			:live_id="id" 
			:tabName="tabName"
		/>
		<!-- 收货地址填写弹框 -->
		<addressform 
			:addressShow.sync="addressShow" 
			:applyForm='applyForm' 
			:userId='userId' 
			:live_id="id" 
			:lotteryinfo="lotteryinfo" 
			@fnaddressSubmit="fnaddressSubmit"
		/>
		<!-- 公众号、直播间邀请码、直播签到弹框 -->
		<popdialog 
			:liveinfo="liveinfo" 
			:qrShow.sync="qrShow" 
			:inviteCodeShow="inviteCodeShow" 
			:signShow.sync="signShow" 
			:userId='userId' 
			:live_id="id" 
			@fnSubmitInviteCode="onSubmitInviteCode" 
			@fnclosesign="fnclosesign"
		/>
		<!-- 抽奖中奖，奖品相关弹框 -->
		<lottery 
			:myprizeshow.sync="myprizeshow" 
			:winShow.sync="winShow" 
			:giftShow.sync="giftShow" 
			:lotteryShow.sync="lotteryShow" 
			:winSelf="winSelf" 
			:allLottery="allLottery" 
			:mywinnerLit="mywinnerLit" 
			:allLotteryList="allLotteryList" 
			:lotteryinfo="lotteryinfo" 
			:winUsersAni="winUsersAni" 
			@fnaddress="fnopenaddress" 
			@openAlllottery="openAll" 
			@fnopenmyprize="fnmyprize" 
			@fnopenAdress="openAdress" 
			@fnlotteryClose="lotteryClose"
		/>
		<!-- 邀请相关弹框 -->
		<sharedialog 
			ref="sharedialogs" 
			:inviteCardShow.sync='inviteCardShow' 
			:liveinfo="liveinfo" 
			@fnopenRank="openRank" 
			:myRank="myRank" 
			:userinfo="userinfo" 
			:share_url="share_url"
		/>
		<!--下定金弹窗-->
		<dingpriceform 
			:userId="userId" 
			:live_id="id" 
			:showDingform.sync="showDingform" 
			:goodDetail="goodDetail" 
			@closeshowdingform="closeDingform"
			@addhasToPAyCount="gethasToPAyCount"
			@refreshGoodDetail="fetchGoodDetail"
			@login="wxLogin"
		/>
		<!--营业执照-->
		<van-popup
			v-model="showLicense"
			closeable
			close-icon="close"
			position="bottom"
			:style="{ height: '90%' }"
			overlay-class="license-popup"
			class="license_popup"
			@close="handleLicenseClose"
		>
			<div class="imgs">
				<img :src="liveinfo.avatar" alt="" />
			</div>
			<h1>{{liveinfo.distributor_name}}的认证说明</h1>
			<div class="infos">
				<p>企业认证详情</p>
				<ul>
					<li>
						<span>企业名称</span>
						<div>{{liveinfo.distributor_name}}</div>
					</li>
					<li>
						<span>资质证照</span>
						<img :src="liveinfo.license" class="preview-img" @click="previewImage([liveinfo.license], 0)" />
					</li>
				</ul>
				<small>资质证照说明：该资质证照由账号主体自行上传、提供，如与实际情况不符，可向平台反馈。</small>
			</div>
		</van-popup>
		<!--邀请榜收货地址填写-->
		<van-dialog class="sign-dialog" v-model="showInviteAddress" width="300px" :show-confirm-button="false">
			<p class="tip">请中奖用户填写收货地址！</p>
			<van-form @submit="onSubmitAddress">
				<van-field border v-model="inviteinfo.link_name" name="用户名" placeholder="请输入姓名" />
					<van-field border v-model="inviteinfo.link_phone" maxlength="11" name="手机号" placeholder="请输入手机号" />
					<van-field readonly clickable v-model="invite_addres.area" name="area" :value="value" placeholder="请选择地区" @click="area_show = true" />
					<van-field border v-model="invite_addres.area_deatail" name="地址" placeholder="请输入详细地址" />
					<van-button
							native-type="submit"
							style="margin-top: 16px;margin-bottom: 16px; background-color: #1ea0d9; color: #fff; height: 25px; width: 75px; line-height: 25px"
							>提交</van-button
					>
			</van-form>
			<div class="delButton" @click="closeAddress"><van-icon name="cross" color="#111" /></div>
		</van-dialog>
		<!-- 地区弹窗 -->
		<van-popup v-model="area_show" position="bottom">
				<van-area :area-list="areaList" @confirm="onConfirmAddress" @cancel="area_show = false" />
		</van-popup>
	</div>
</template>
<script>
import * as api from "@/api/live";
import axios from "axios";
import { Dialog, ImagePreview } from "vant";
import jweixin from "jweixin-module/lib/index.js";
import Chat from "./common/chat/Chat.vue";
import TcPlayer from "./common/TCPlayer.vue";
import askdriveform from "./askdriveform.vue";
import askpriceform from "./askpriceform.vue";
import dingpriceform from './dingpriceform.vue';
import applyform from "./applyform.vue";
import addressform from "./addressform.vue";
import popdialog from "./popdialog.vue";
import sharedialog from "./sharedialog.vue";
import lottery from "./lottery.vue";
import liverlist from './liverlist.vue'
import coucherlist from './coucherlist.vue'
import { randomList, getUUID, encodeSearchParams, checkMobile, checkName } from "@/utils/utils.js";
import io from "socket.io-client";
import Vue from "vue"
import { socketio } from './common/chat/socketio.js'
import {difftime,nowDate} from '../utils/duringdate'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import wxapis from '../weixin.js'
import { formatIsoToDateStart } from "@/utils/utils.js";
import { areaList } from "@vant/area-data";

export default {
	props: {},
	components: {
		Chat,
		TcPlayer,
		askdriveform,
		askpriceform,
		applyform,
		addressform,
		popdialog,
		lottery,
		sharedialog,
		liverlist,
		dingpriceform,
		coucherlist
	},
	data() {
		return {
			pull_flow_url: "",
			inviteId: "",
			tabName: "",
			isplay: false,
			id: "43",
			userId: "",
			wxCode: localStorage.getItem("wxCode"),
			apply_id: "",
			applyArea: "",
			user: [],
			menuList: [],
			goodsList: [],
			rankList: [],
			myRankList: [],
			liveinfo: {
			},
			userinfo: {
				0: {avatar:''},
			},

			lotteryList: [],
			lotteryinfo: {},

			/** 抽奖中(动画等待) */
			lotteryDrawing: false,
			lotteryInterval: 0,
			attendUser: [],
			winUser: [],
			winUsersAni: [],
			allLottery: [],
			winSelf: false,
			myRank: {
				invite_num:''
			},
			page: 1,
			mypage: 1,
			qrShow: false,
			activeName: "互动评论",
			applyFormShow: false,
			inviteCardShow: false,
			inviteListShow: false,
			showAreaApply: false,
			AdressAreaShow: false,
			moreFunctionShow: false,
			inviteCodeShow: false,
			signShow: false,
			lotteryShow: false,
			addressShow: false,
			showArea: false,
			giftShow: false,
			winShow: false,
			myprizeshow:false,
			mywinnerLit:[],
			applyForm: {},
			allLotteryList: [],
			time: 0,
			lotterytime: 0,
			// value: "",
			likenum: 0,
			lotteryId: "",
			isMute: false,
			rankTotal: 0,
			isBottom: false,
			getlLotteryInterval: 0,
			invitationCard: {
				image: "",
				qrcode: { url: "" },
			},
			lotterytimeBagShow: false,

			/** 红包 */
			redShow: false,
			redpacketShow: false,
			recieveShow: false,
			redinfo: {
				redpacket: {
					user: {},
				},
				user: {},
			},
			redDetail: {
				user: {},
				redpacket: {},
			},
			redpass: "",

			wssbaseurl: "",
			chatLotteryShow: false,
			inviteIconShow: false,
			inviteShareShow:false,
			queryShow: false,
			goodDetail: {
				pic_list: [],
			},
			area: "",
			showQueryArea: false,
			isRedpacketShow: false,
			isMobile: '',
			topMessage: {
				content: "",
				name: "",
			},
			timeNoticeShow: false,
			showTryform:false,
			share_url:'',
			// pc_url:'',
			// 更改状态的红包id
			redremainId: "",
			uuid:'',
			$socket:'',
			iswater:false,
			liverlistDate:[],
			livertimer:null,
			isApp:false,
			visitorId:'',
			params_token:"",

			showDingform: false,
			hasToPAyCount: 0,
			depositTimeConfig: { // 下定金时间配置
				start_time: '',
				end_time: ''
			},
			hasOrderRecord: false,
			orderList: [],
			showLicense: false,
			showInviteAddress: false,
			inviteinfo: {
				link_name: '',
				link_phone: ''
			},
			invite_addres: {
				area: '',
				area_deatail: ''
			},
			area_show: false,
			areaList,

		};
	},
	filters: {
		elip(val) {
			val = String(val);
			if (val.length > 12) {
				return val.substr(0, 12) + "...";
			} else {
				return val;
			}
		},
	},
	computed: {},
	watch: {
		menuList: {
			immediate: true,
			handler (newVal) {
				console.log('menuList变化后更新', newVal)
				this.depositTimeConfig = this.getDepositTimeConfig()
			}
		},
		hasToPAyCount(val) {
			console.log('首页val', val)
			if (val) {
				this.$nextTick(() => {
					this.getOrderList();
				});
			}
		}
	},
	created() {
		this.initUI()
		this.initData()
	},
	mounted() {
		const queryParams = new URLSearchParams(window.location.search)
		const referer = queryParams.get('referer')
		console.log('referer',referer)
		if(referer && referer == "app"){
			this.isApp = true
		}else{
			this.isApp = false
		}
		// 兜底再消费一次 URL token（不刷新页面）
		this.consumeUrlToken()
	},
	methods: {
		initUI(){
			window.indexVue = this
			// 进页立刻消费并清除 URL 中的 token，避免复制/默认分享带上 JWT
			this.consumeUrlToken()
			if (this.$route.query.live_id != null) {
				this.id = this.$route.query.live_id;
			}
			if (this.$route.query.invite_user != null) {
				this.inviteId = this.$route.query.invite_user;
			}
			let url = window.location.href; //获取当前url
			const isinclude = url.includes("code=");
			if (isinclude == true) {
				let dz_url = url.split("#")[0]; //获取#/之前的字符串
				console.log(dz_url.split("?"));
				let cs_s = dz_url.split("?")[1]; //获取?之后的参数字符串

				let cs_arr = cs_s.split("&"); //参数字符串分割为数组

				let cs = {};

				for (let i = 0; i < cs_arr.length; i++) {
					//遍历数组，拿到json对象

					cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
				}
				let code = cs.code;

				if (code != null) {
					localStorage.setItem("wxCode", code);
				} else {
					localStorage.removeItem("wxCode");
				}
			} else {
				localStorage.removeItem("wxCode");
			}

			this.lotteryId = localStorage.getItem("lottery" + this.id) || "";

			if(localStorage.getItem('uuid')){
				this.uuid = localStorage.getItem('uuid')
			}else{
				this.uuid = getUUID()
			}

			this.getLiveinfo(true);
			this.getTop();
			this.getLotteryList()
			this.getApply();
		},
		initData(){
			this.getrelateDate()
			this.$on('lotteryUpdate', this.updateLotteryList)
		},
		handleHasOrder(hasOrder) {
			this.hasOrderRecord = hasOrder;
		},
		fntoliver(id){
			this.$router.push({ name: 'home', query: { live_id: id } }).catch(err => {})
		},
		fntoweb(type,info){
			if(type == 2){////支付定金
				window.location.href= process.env.VUE_APP_BASE_URL+"/reservePay/"+info.product_id
				return false
			}
			if(type == 1 && !info.coupon_configs[0].total){//优惠券
				this.$toast('优惠券已被抢光');
				return false
			}
			window.location.href= process.env.VUE_APP_BASE_URL+"/coupons/"+info.coupon_configs[0].id
		},
		checkRTCPeerConnectionSupport(){
			return !!(
				window.RTCPeerConnection ||
				window.webkitRTCPeerConnection ||
				window.mozRTCPeerConnection
			);
		},
		// 拉流播放
		testLive() {
			this.isplay = true;
			if (this.liveinfo.live_status == 2) {
				setTimeout(() => {
					this.pull_flow_url = this.liveinfo.pull_flow_url;
					// this.pull_flow_url = this.liveinfo.pull_url['webrtc']
				}, 500);
			} else if (this.liveinfo.live_status == 3 && this.liveinfo.playback_status == 1) {
				setTimeout(() => {
					this.pull_flow_url = this.liveinfo.playback_url;
				}, 500);
			}

		},
		getrelateDate(){// 相关直播间
			const data = { live_id: this.id };
			api.getrelated(data).then((res) => {
				if (res.code == 200) {
					this.liverlistDate = res.result.data
				// 	for(var i=0;i<this.liverlistDate.length;i++){
				// 		var item = this.liverlistDate[i]
				// 		this.$set(item,"ss")
				// 	}
				// 	if(this.livertimer){
				// 		clearInterval(this.livertimer)
				// 	}
				}
			})
		},
		// getTimeList(){
		// 	this.livertimer = setInterval(() => {
		// 		for (var key in this.liverlistDate) {
		// 				var nowtime = nowDate('/')
		// 				var endtime = this.liverlistDate[key].start_time_with_time.replace(/-/g,'/')
		// 				if(new Date(endtime).getTime() - new Date(nowtime).getTime() > 0){
		// 				var difftimeobj = difftime(nowtime,endtime)
		// 				this.liverlistDate[key]["dd"] = difftimeobj.days
		// 				this.liverlistDate[key]["hh"] = difftimeobj.hours < 10? "0" + difftimeobj.hours : difftimeobj.hours;
		// 				this.liverlistDate[key]["mm"] = difftimeobj.minutes < 10? "0" + difftimeobj.minutes : difftimeobj.minutes;
		// 				this.liverlistDate[key]["ss"] = difftimeobj.seconds < 10? "0" + difftimeobj.seconds : difftimeobj.seconds;
		// 				}else{
		// 				this.liverlistDate[key]["dd"] = 0;
		// 				this.liverlistDate[key]["hh"] = 0;
		// 				this.liverlistDate[key]["mm"] = 0;
		// 				this.liverlistDate[key]["ss"] = 0;
		// 				if(this.liverlistDate[key].live_status == 1){
		// 					this.liverlistDate[key].live_status = 2
		// 				}

		// 				}
		// 		}
		// 	},1000)
		// },
		// 获取直播详情
		getLiveinfo(bool, mute) {
			const data = { live_id: this.id };
			api.getLive(data).then((res) => {
				// console.log(res, "liveinfo");
				if (res.code === 200) {
					this.liveinfo = res.result;
					setTimeout(() => {
						this.likenum = this.liveinfo.like_num;
					}, 1000);
					setTimeout(() => {
						document.title = this.liveinfo.name;
						var iframe = document.createElement("iframe");
						iframe.style.visibility = "hidden";
						iframe.style.width = "1px";
						iframe.style.height = "1px";
						iframe.onload = function () {
							setTimeout(function () {
								document.body.removeChild(iframe);
							}, 0);
						};
						document.body.appendChild(iframe);
					}, 1000);
					if (this.liveinfo.live_status == 2 || this.liveinfo.live_status == 3) {
						this.testLive()
					}
					// 判断强制实名和进行中的需要加水印
					setTimeout(() => {
						if(this.liveinfo.is_real && this.liveinfo.live_status == 2){
							this.iswater = true
						}
					}, 500);
					// 判断直播间禁言，是否显示红包
					if (this.liveinfo.live_status == 3) {
						this.isMute = true;
					}
					if (this.liveinfo.shutup_status == 2) {
						this.isMute = true;
					}
					if (this.liveinfo.red_packet_show == 1) {
						this.isRedpacketShow = true;
					}

					if (this.liveinfo.desc != "" && this.liveinfo.desc != null) {
						this.liveinfo.desc = this.liveinfo.desc.replace(/<img/g, "<img style='max-width:100%;height:auto;'");
					}
					if(this.liveinfo.poster.length){//上传了海报就开启分享icon
						this.inviteShareShow = true
					}

					// 距离直播开始时间
					let dateStart = new Date(res.result.start_time).getTime();
					let dateNow = new Date().getTime();
					this.time = dateStart - dateNow;

					if (bool) {
						console.log('userid',this.userId)
						if (this.liveinfo.tencent_qrcode != null && this.liveinfo.tencent_qrcode != "") {//放在这里，只有初始化页面执行一次
							this.qrShow = true;
						}
						this.getMenu();
						// 邀请海报进入：本会话强制当前微信重新授权一次，避免复用串号的旧 token
						if (this.shouldForceInviteOauth()) {
							this.wxLogin()
							return
						}
						if(this.liveinfo.is_real || this.liveinfo.encryption_status == 2){//判断如果是强制签到或者直播加密的就先授权登录
							this.wxLogin()
						}else{
							socketio.socketInit()
							console.log('usererrrrrr============', this.userId)
						}
						console.log('user---id', this.userId)
					}
					if (mute) {
						this.liveShutDown();
					}
				}
			});
		},
		// 获取置顶消息
		getTop() {
			const data = { live_id: this.id };
			api.getTopMaessage(data).then((res) => {
				if (res.result != null) {
					this.topMessage.content = res.result.content;
					this.topMessage.name = res.result.nick_name;
				}
			});
		},
		// 点击查看我的奖品
		fnmyprize(){
			this.getmywinner()
			this.myprizeshow = true
		},
		getmywinner(){
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			api.getmywinner({live_id:this.id,user_id:this.userId}).then((res) => {
				this.mywinnerLit = res.result
			})
		},
		fnopenaddress(id){
			this.addressShow = true
			this.lotteryinfo.id =id
		},
		// 设定分享信息（签名用当前页干净 URL；分享 link 永不带 token；有 userId 再配邀请分享）
		getShareInfo() {
			console.log('this.userId',this.userId)
			if (this.userId) {
				this.getOrderList()
			}
			// 允许分享时必须等登录完成，避免 invite_user 为空或串号
			if (this.liveinfo.is_share && !this.userId) {
				return
			}
			const signUrl = this.getJsSignUrl()
			console.log('jssdk signUrl', signUrl)
			api.getJssdk(encodeURIComponent(signUrl)).then((res) => {
				if(!this.liveinfo.is_share){//禁止分享
					jweixin.config({
						debug: false,
						appId: res.result.appId, // 必填，公众号的唯一标识
						timestamp: res.result.timestamp, // 必填，生成签名的时间戳
						nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
						signature: res.result.signature, // 必填，签名，见附录1
						jsApiList:["openEnterpriseChat","openChatWithMsg","selectExternalContact","openUserProfile","thirdPartyOpenPage","getCurExternalContact","onMenuShareTimeline","onMenuShareAppMessage","hideOptionMenu","hideMenuItems"],

					})
					jweixin.ready(() => {
						jweixin.hideOptionMenu();
						jweixin.hideMenuItems({
							menuList: ["menuItem:share:appMessage", "menuItem:share:timeline","menuItem:share:qq","menuItem:share:weiboApp","menuItem:share:QZone","menuItem:copyUrl"]
						});
					})
					return false
				}
				jweixin.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: res.result.appId, // 必填，公众号的唯一标识
					timestamp: res.result.timestamp, // 必填，生成签名的时间戳
					nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
					signature: res.result.signature, // 必填，签名
					jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
				});
				jweixin.ready(() => {
					// 分享链接只含 live_id + 当前用户 invite_user，禁止带 token
					const shareUrl =
						process.env.VUE_APP_BASE_URL + "/html/live/mobile/#/HomeView?live_id=" +
						this.id +
						"&invite_user=" +
						this.userId;
					let shareData = {
						title: this.liveinfo.share_title || "", //分享的标题
						desc: this.liveinfo.share_desc || "", //分享的描述
						link: shareUrl, //分享的链接
						imgUrl: this.liveinfo.share_cover || "", //分享的图片链接
						success(response) {
							//配置成功之后的回调（并不是分享成功之后的回调，这个地方是个坑，要注意下）
							console.log("分享设置成功");
						},
					};

					jweixin.updateAppMessageShareData(shareData);
					jweixin.onMenuShareAppMessage(shareData);
					jweixin.updateTimelineShareData(shareData);
					jweixin.onMenuShareTimeline(shareData);
				});
			});
		},
		// 更新观看数
		changeWatch(data) {
			this.liveinfo.watch = data.watch_num;
		},
		// 获取直播菜单tab栏内容
		getMenu() {
			const data = { live_id: this.id };
			api.getLiveMenu(data).then((res) => {
				if (res.code === 200) {
					this.menuList = res.result;
					// console.log(this.menuList, "menu");
					this.menuList.sort((a, b) => {
						return parseInt(a.sort) - parseInt(b.sort);
					});
					this.menuList.forEach((item) => {
						if (item.name == "邀请榜单") {
							this.inviteIconShow = true;
						}
					});
					this.tabName = this.menuList[0].name;
					this.activeName = this.tabName
				}
			});
		},
		// 切换tab
		clickTab(name) {
			console.log(name);
			this.tabName = name;
			if (name === "商品展示") {
				if (!this.userId) {
					this.wxLogin()
					return false;
				}
				this.getGoodsList();
			} else if (name == "在线报名") {
				// this.getApply();
			} else if (name == "邀请榜单") {
				this.getRankList(false);
			} else if (name == "互动评论") {
				// this.getUser();
			} else if (name == "内嵌链接") {
				const index = this.menuList.findIndex((item) => {
					return item.name == "内嵌链接";
				});
				console.log(this.menuList[index].url);
				this.jump(this.menuList[index].url);
			}
		},
		getMenuContent(tabName) {
			const menuItem = this.menuList.find(item => item.name === tabName)
			if(menuItem && menuItem.content) {
				return menuItem.content.replace(/<img/g, '<img style="max-width:100%;height:auto;"')
			}
			return '<div style="text-align:center;padding:20px;color:#999;">暂无相关内容</div>'
		},
		// 判断当前时间是否在指定时间段内
		isInTimeRange(startTime, endTime) {
			console.log('商品上下架时间item', startTime, endTime)
			if (!startTime || !endTime) return false // 无时间配置默认不可点击
			const now = new Date().getTime()
			const start = new Date(startTime).getTime()
			const end = new Date(endTime).getTime()
			return now >= start && now <= end
		},
		// 获取商品展示/下定金相关的时间配置
		getDepositTimeConfig() {
			// 假设menuList中"商品展示"项包含时间配置，可根据实际字段调整
			const targetMenu = this.menuList.find(item => item.name === '商品展示')
			if (targetMenu && targetMenu.start_time && targetMenu.end_time) {
				return {
					start_time: targetMenu.start_time,
					end_time: targetMenu.end_time
				};
			}
			return { start_time: '', end_time: '' }
		},
		// 获取产品列表
		getGoodsList() {
			const data = { live_id: this.id };
			api.getGoods(data).then((res) => {
				if (res.code === 200) {
					this.goodsList = res.result.data;
					if (this.goodDetail.id) {
						const latestGood = this.goodsList.find(item => item.id === this.goodDetail.id)
						if (latestGood) {
							this.goodDetail = latestGood
						}
					}
				}
			});
		},
		// 获取报名表信息
		getApply() {
			const data = { live_id: this.id };
			api.getApplyForm(data).then((res) => {
				if (res.result !== null && res.result.apply != null) {
					this.apply_id = res.result.apply.id;
					this.applyForm = res.result.apply;
				}
			});
		},
		// 获取排行榜单
		getRankList(bool) {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			if (bool) {
				if (this.page * 15 < this.rankTotal) {
					console.log(this.rankTotal);
					this.page = this.page + 1;
					// if (this.page * 15 >= this.rankTotal) {
					// 	this.isBottom = true;
					// }
				} else {
					this.isBottom = true;
					return;
				}
			} else {
				this.isBottom = false;
				this.page = 1;
			}
			const data = { live_id: this.id, page: this.page, user_id: this.userId };
			api.getRank(data).then((res) => {
				console.log("getRank", res);
				if (res.code === 200) {
					if (bool) {
						this.rankList = [...this.rankList, ...res.result.data.ranking_list];
					} else {
						this.rankTotal = res.result.total;
						this.rankList = res.result.data.ranking_list;
						this.myRank = res.result.data.my_ranking;
					}

					console.log("rankList", this.rankList);
				}
			});
		},
		// 获取我的邀请
		getMyRankList(bool) {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			if (bool) {
				this.mypage = this.mypage + 1;
			} else {
				this.mypage = 1;
			}
			const data = { live_id: this.id, page: this.mypage, user_id: this.userId };
			api.getMyRank(data).then((res) => {
				console.log("getMyRank", res);
				if (res.code === 200) {
					if (bool) {
						this.myRankList = [...this.myRankList, ...res.result.data.ranking_list];
					} else {
						this.myRankList = res.result.data.ranking_list;
						// this.myRank = res.result.data.my_ranking;
					}

					console.log("myRankList", this.myRankList);
				}
			});
		},
		// 获取礼物列表
		getGiftList() {
			const data = {};
			api.getGift(data).then((res) => {
				console.log(res, "gift");
				if (res.code === 200) {
				}
			});
		},
		// 获取全部抽奖中奖名单
		getlotteryAll() {
			const data = { live_id: this.id };
			api.getAllLotteryUser(data).then((res) => {
				console.log(res, "all");
				if (res.code === 200) {
					this.allLottery = res.result;
					let arr = [];
					arr = this.allLottery.filter((item) => {
						return item.winner_user.length > 0;
					});
					if (arr.length > 0) {
						this.winShow = true;
					} else {
						this.winShow = true;
					}
				}
			});
		},
    async getLotteryList() {
      const data = { live_id: this.id}
      const res = await api.getLottery(data);
			this.updateLotteryList(res.result.lottery_data,1)
    },
    updateLotteryList(data,type) {
		console.log('updateLotteryList', data)
      let ongoingList = [];
      let dateNow = new Date().getTime()
      this.allLotteryList = data;
      if (this.allLotteryList.length > 0) {
        this.chatLotteryShow = true;
      }
      ongoingList = this.allLotteryList.filter((item) => {
        return (
            dateNow > new Date(item.starttime).getTime() &&
            dateNow < new Date(item.starttime).getTime() + item.duration * 1000 &&
            item.status == 1
        );
      });

      this.lotteryList = data.filter((item) => {
        return item.status == 1 && item.state_status == 2;
      });
      this.lotteryList = this.lotteryList.sort((a, b) => {
        return new Date(b.starttime).getTime() - new Date(a.starttime).getTime();
      });

      if (ongoingList.length > 0 || this.lotteryList.length > 0) {
        if (ongoingList.length > 0) {
          this.lotteryinfo = ongoingList[0];
        } else {
          this.lotteryinfo = this.lotteryList[0];
        }

        if (this.lotterytime == 0) {
			if(type == 1){//刚进来
            //   const dateStart = new Date(this.lotteryinfo.starttime).getTime()+this.lotteryinfo.duration * 1000
            //   const dateNow = new Date().getTime()
            //   this.lotterytime = dateStart - dateNow
			  this.lotterytime =this.lotteryinfo.duration * 1000

            }else{
              this.lotterytime = this.lotteryinfo.duration * 1000
            }
        }
        if (this.lotterytime > 0 && this.lotteryinfo.state_status == 2) {
          this.lotterytimeBagShow = true;
        }
        if (this.lotteryinfo.state_status == 4) {
          this.lotterytimeBagShow = false;
          this.lotterytime = 0;
        }

      }
    },
		// 获取当前抽奖
		getlotteryinfo() {
			const data = { live_id: this.id };
			api.getLottery(data).then((res) => {
				console.log(res, "lottery");
				if (res.code === 200) {
					let ongoingList = [];
					let dateNow =new Date().getTime();
					this.allLotteryList = res.result.lottery_data;
					if (this.allLotteryList.length > 0) {
						this.chatLotteryShow = true;
					}
					ongoingList = this.allLotteryList.filter((item) => {
						return (
							dateNow > new Date(item.starttime).getTime() &&
							dateNow < new Date(item.starttime).getTime() + item.duration * 1000 &&
							item.status == 1
						);
					});
					this.lotteryList = res.result.lottery_data.filter((item) => {
						return item.status == 1 && item.state_status != 1;
					});
					this.lotteryList = this.lotteryList.sort((a, b) => {
						return new Date(b.starttime).getTime() - new Date(a.starttime).getTime();
					});
					// console.log(this.lotteryList, "lotteryList");
					if (ongoingList.length > 0 || this.lotteryList.length > 0) {
						if (ongoingList.length > 0) {
							this.lotteryinfo = ongoingList[0];
						} else {
							this.lotteryinfo = this.lotteryList[0];
						}
						// console.log(this.lotteryinfo, "lotteryinfo");
						let dateStart = new Date(this.lotteryinfo.starttime).getTime() + this.lotteryinfo.duration * 1000;
						if (this.lotterytime == 0) {
							// this.lotterytime = dateStart - dateNow > 0 ? dateStart - dateNow : 0;
							this.lotterytime = this.lotteryinfo.duration * 1000
						}
						// console.log(this.lotterytime, "lotterytime");
						if (this.lotterytime > 0 && this.lotteryinfo.state_status == 2) {
							this.lotterytimeBagShow = true;
						}
						if (this.lotteryinfo.state_status == 4) {
							this.lotterytimeBagShow = false;
							this.lotterytime = 0;
						}

					}
				}
			});
		},
		// 实时获取当前抽奖（未使用）
		lotteryCount(data) {
			console.log(data, "lotterysocket");
			console.log(this.lotteryId);
			if (this.lotteryId != data.lottery) {
				this.lotteryId = data.lottery;
				localStorage.setItem("lottery" + this.id, this.lotteryId);
				console.log(this.lotteryId);
				console.log(this.lotteryinfo);
				this.getlotteryinfo();
			}
		},
		// 获取抽奖参与中奖人员
		getlotteryUser() {
			const data = { user_id: this.userId, live_id: this.id, lottery_id: this.lotteryinfo.id };
			console.log(JSON.stringify(data));

			// this.lotteryDrawing = false;
			api.getLotteryUser(data).then((res) => {
				if (res.code === 200) {
					console.log("抽奖结果", res);
					this.attendUser = res.result.user_list;
					this.winUser = res.result.winner_list;
					this.isMobile = res.result.winner_mobile;
					if (this.attendUser.length > 0 && this.attendUser != null && this.winUser.length > 0) {
						this.lotteryShow = true;
						this.winSelf = !!this.winUser.find((_user) => _user.user_id == this.userId);
						this.winUsersAni = [];
						this.winUsersAni = this.winUser;
					} else {
						this.lotteryShow = true;
					}
				}
			});
		},
		// 关闭抽奖弹框
		lotteryClose() {
			if (this.lotteryInterval) {
				clearInterval(this.lotteryInterval);
			}
			this.lotteryShow = false
			setTimeout(()=>{
				this.attendUser = [];
				this.winUser = [];
				this.winUsersAni = [];
				this.winSelf = false;
			},500)

			// this.lotteryDrawing = false;
		},
		// 点击右侧报名表
		handleApply() {
			this.getApply();
			this.applyFormShow = true;
		},
		fnaddressSubmit(data){
			this.isMobile = data;
			this.addressShow = false
			this.lotteryShow = false
			this.getmywinner()
		},
		dingJin(item) {
			console.log('下定金',item)
			this.ensureLoginAndRefreshUser().then((ok) => {
				if (!ok) return
				this.goodDetail = JSON.parse(JSON.stringify(item));
				console.log('dingjin--item',this.goodDetail);
				this.showDingform = true
			})
		},
		closeDingform() {
			this.showDingform = false
		},
		// 点击询价
		openQuery(item) {
			this.goodDetail = JSON.parse(JSON.stringify(item));
			console.log('询价item',this.goodDetail);
			this.queryShow = true;
		},
		// 点击预约试驾
		openTry(){
			this.showTryform = true;
		},
		// 关闭预约试驾弹框
		closeTryform(){
			this.showTryform = false;
		},
		// 关闭询价弹框
		closepriceform(){
			this.queryShow = false
		},
		// 直播结束禁言
		liveShutDown(data) {
			setTimeout(() => {
				this.isMute = true;
			}, 500);
		},
		// 禁言
		shutUp(data) {
			if (this.userId == data.user_id || data.user_id == 0) {
				setTimeout(() => {
					this.isMute = true;
				}, 500);
			}
		},
		// 取消禁言
		unShutUp(data) {
			if (this.userId == data.user_id || data.user_id == 0) {
				setTimeout(() => {
					this.isMute = false;
				}, 500);
			}
		},
		// 订阅提醒
		getNotice() {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			const data = { live_id: this.id, user_id: this.userId, attention: 1 };
			api.attentionNotice(data).then((res) => {
				if (res.code === 200) {
					this.$toast.success("订阅提醒已开启");

					this.getLiveinfo(false);
				} else {
					this.$toast(res.message);
				}
			});
		},
		/**
		 * 进页立刻消费 URL 中的 token 并 replaceState 清掉，避免复制/默认分享带上 JWT
		 * 不依赖 flagtoken + router.go(0) 竞态
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 * @returns {string} 落盘后的 token，无则空串
		 */
		consumeUrlToken() {
			let token = ''
			try {
				const url = new URL(window.location.href)
				token = url.searchParams.get('token') || ''
				if (token) {
					this.params_token = token
					localStorage.setItem('live_access_token', token)
					this.markInviteOauthDone()
					url.searchParams.delete('token')
					history.replaceState({}, '', url.toString())
				}
			} catch (e) {
				const match = window.location.search.match(/[?&]token=([^&]*)/)
				token = match ? decodeURIComponent(match[1]) : ''
				if (token) {
					this.params_token = token
					localStorage.setItem('live_access_token', token)
					this.markInviteOauthDone()
				}
			}
			localStorage.removeItem('flagtoken')
			// 记录 iOS 签名用的首次进入 URL（已去 token）
			if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
				window.entryUrl = location.href.split('#')[0]
			}
			return token || this.params_token || localStorage.getItem('live_access_token') || ''
		},
		/**
		 * 微信 JSSDK 签名 URL：Android 用当前页，iOS 用首次进入页；均去掉 token
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 * @returns {string}
		 */
		getJsSignUrl() {
			const raw = /(Android)/i.test(navigator.userAgent)
				? location.href.split('#')[0]
				: (window.entryUrl || location.href.split('#')[0])
			try {
				const u = new URL(raw)
				u.searchParams.delete('token')
				return u.toString()
			} catch (e) {
				return String(raw).replace(/([?&])token=[^&]*/g, '$1').replace(/[?&]$/, '')
			}
		},
		/**
		 * 获取去掉 token 的当前页地址，避免授权回跳/分享链路带上登录态造成串号
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 */
		getCleanPageUrl() {
			try {
				const url = new URL(window.location.href)
				url.searchParams.delete('token')
				return url.toString()
			} catch (e) {
				return window.location.href.replace(/([?&])token=[^&]*/g, '$1').replace(/[?&]$/, '')
			}
		},
		/**
		 * 邀请进入会话标记：本直播间已完成当前微信授权
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 */
		getInviteOauthKey() {
			return `invite_oauth_${this.id}`
		},
		/**
		 * 标记邀请进入已完成授权
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 */
		markInviteOauthDone() {
			if (this.inviteId) {
				sessionStorage.setItem(this.getInviteOauthKey(), '1')
			}
		},
		/**
		 * 邀请海报进入且非授权回跳时，强制清掉可能串号的旧 token 并重新授权
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 * @returns {boolean} 是否需要强制走 wxLogin
		 */
		shouldForceInviteOauth() {
			if (!this.inviteId) {
				return false
			}
			// 本会话已完成邀请进入授权（含 OAuth 回跳刚消费 token）
			if (sessionStorage.getItem(this.getInviteOauthKey()) === '1') {
				return false
			}
			// 授权回跳：consumeUrlToken 已写入 params_token / live_access_token
			if (this.params_token && localStorage.getItem('live_access_token')) {
				this.markInviteOauthDone()
				return false
			}
			localStorage.removeItem('live_access_token')
			return true
		},
		/**
		 * 下定金/分享海报前确保已登录，并刷新为当前微信身份
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 * @returns {Promise<boolean>}
		 */
		async ensureLoginAndRefreshUser() {
			if (!localStorage.getItem('live_access_token')) {
				this.wxLogin()
				return false
			}
			const ok = await this.refreshCurrentUser()
			return ok
		},
		/**
		 * 用当前 token 拉取用户信息，校正 userId/userinfo，失败则重新授权
		 * @author 于
		 * @date 2026-08-21 10:39:36
		 * @returns {Promise<boolean>}
		 */
		async refreshCurrentUser() {
			try {
				const params = { live_id: this.id, token: localStorage.getItem('live_access_token') }
				const response = await api.getUserinfo(params)
				if (response.code == 200 && response.result) {
					this.userinfo = response.result
					if (response.result.user_id) {
						this.userId = response.result.user_id
					}
					return true
				}
			} catch (e) {
				console.error('刷新用户信息失败', e)
			}
			localStorage.removeItem('live_access_token')
			this.wxLogin(1)
			return false
		},
		wxLogin(type) {//type为1是登录失效
			// 统一消费 URL token（replaceState，不刷新）
			this.consumeUrlToken()
			const cleanBackUrl = this.getCleanPageUrl()
			if(type){//token过期 登录失效
				localStorage.removeItem('live_access_token')
				window.location.href =
				`${process.env.VUE_APP_BASE_URL}/api/live/v1/wechat/oauth/middle?` +
				"backUrl=" +
				encodeURIComponent(`${process.env.VUE_APP_BASE_URL}/api/live/v1/wechat/login/?uuid=${this.uuid}&live_id=${this.id}&invite_user=${this.inviteId || ''}&backUrl=`+encodeURIComponent(cleanBackUrl));
				return false
			}
			if (localStorage.getItem('live_access_token')) {
				console.log(45677888)
				socketio.socketInit()
				return
			}

			window.location.href =
				`${process.env.VUE_APP_BASE_URL}/api/live/v1/wechat/oauth/middle?` +
				"backUrl=" +
				encodeURIComponent(`${process.env.VUE_APP_BASE_URL}/api/live/v1/wechat/login/?uuid=${this.uuid}&live_id=${this.id}&invite_user=${this.inviteId || ''}&backUrl=`+encodeURIComponent(cleanBackUrl));
		},
		async getUserInfo() {
			const params = {live_id: this.id, token: localStorage.getItem('live_access_token')}
			const response = await api.getUserinfo(params)
			if(response.code == 200){
				this.userinfo = response.result
				if (response.result && response.result.user_id) {
					this.userId = response.result.user_id
				}
			}
		},
		// 关注
		getAttention() {
			if (!localStorage.getItem('live_access_token')) {
				this.wxLogin()
        return false;
			}
      const data = {live_id: this.id, user_id: this.userId, attention: 1};
      api.attentionLive(data).then((res) => {
        if (res.code === 200) {
          this.$toast.success("关注成功");
        } else {
          this.$toast(res.message);
        }
      });
		},
		// 取消关注
		cancelAttention() {
			Dialog.confirm({
				message: "确定要取消关注吗",
			}).then(() => {
				const data = { live_id: this.id, user_id: this.userId, attention: 2 };
				api.attentionLive(data).then((res) => {
					if (res.code === 200) {
						this.$toast.success("取消关注成功");
						this.getUserInfo();
					} else {
						this.$message({
							message: res.message,
							type: "warning",
							duration: 1500,
						});
					}
				});
			});
		},
		// 提交邀请码
		onSubmitInviteCode(inviteCode) {
			const data = { live_id: this.id, pass: inviteCode, user_id: this.userId };
			api.submitLiveCode(data).then((res) => {
				if (res.result.code != 1) {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">邀请码错误</div>',
						type: "html",
					});
					return false
				}
				this.$toast({
					message: '提交成功',
					type: "html",
				});

				this.inviteCodeShow = false;
				// 判断是否强制实名
				if (this.liveinfo.is_real) {//强制实名，显示实名弹框
					this.openSign(1)
				}
				// if(this.liveinfo.encryption_status!=2 && this.liveinfo.live_status == 2 ){//直播进行中并且没有加密直接播放
				// 	this.$refs.playerVideo.player.play()
				// }

			});
		},
		// 直播倒计时结束
		liveStart() {
			this.getLiveinfo(false);
		},
		// 抽奖倒计时结束
		//更多功能
		openMore() {
			this.moreFunctionShow = true;
		},
		// 显示邀请卡弹窗
		openInviteCard() {
			console.log(this.inviteIconShow)
			this.ensureLoginAndRefreshUser().then((ok) => {
				if (!ok) return
				if(this.inviteShareShow && this.inviteIconShow){
					this.getRankList(false);
					this.inviteCardShow = true;
				}else{
					this.inviteNow()
				}
			})
		},
		// 显示报名表弹窗
		openApplyForm() {
			// this.getApply();
			this.applyFormShow = true;
		},
		// 查看全部中奖名单
		openAll() {
			this.getlotteryAll();
		},
		// 立即邀请
		inviteNow() {
			this.ensureLoginAndRefreshUser().then((ok) => {
				if (!ok) return
				this.$refs.sharedialogs.inviteNows()
			})
		},
		// 查看榜单
		openRank() {
			this.getRankList(false);
			this.getMyRankList(false);
			this.inviteListShow = true;
		},
		openPrice() {
			const data = { live_id: this.id };
			api.getAllLotteryUser(data).then((res) => {
				if (res.success) {
					this.allLottery = res.result;
					let arr = [];
					arr = this.allLottery.filter((item) => {
						return item.winner_user.length > 0;
					});
					if (arr.length > 0) {
						this.giftShow = true;
					} else {
						this.giftShow = true;
					}
				}
			});
		},
		// 点击福袋或抽奖倒计时结束
		openLottery(bool) {
			if (!this.userId) {
        this.wxLogin()
				return false
			}
			if(bool && this.lotterytime != 0){
				this.timeNoticeShow = true
				setTimeout(() => {
					this.timeNoticeShow = false
				}, 1000)
				return false
				}
			setTimeout(() => {
				console.log(this.lotteryinfo, 'openLottery')
				if (this.lotteryinfo) {
					const openTime = new Date(this.lotteryinfo.starttime).getTime() + this.lotteryinfo.duration * 1000
					// 判断当前时间是否小于开始时间
					if (new Date().getTime() < openTime) {
						this.timeNoticeShow = true
						setTimeout(() => {
							this.timeNoticeShow = false
						}, 1000)
					} else {
						this.lotterytime = 0
						this.lotterytimeBagShow = false
						this.getlotteryUser()
					}
				} else {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">还没有抽奖哦</div>',
						type: "html",
					});
				}
			}, 500);
		},
		openAdress() {
			this.addressShow = true;
		},
		// 点击签到
		openSign(type) {//type为1 是自调取函数 不传type是点击图标调取的
			if (!this.userId) {
				this.wxLogin()
				return false;
			}
			// console.log('userinfo',this.userinfo)
			if (this.userinfo.sign_up == "1") {
				if(type!=1){
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">已签到</div>',
						type: "html",
					});
				}

				return;
			}

			// this.signinfo.name = this.userinfo.nick_name;
			this.signShow = true;
		},
		// tab切换
		tabChange(name) {
			// console.log('互动', this.$refs.chatref.chatMsgs)
			this.activeName = name

			if (this.$refs.chatref) {
				this.$refs.chatref.presenturl = '';
			}
      // const image = childComponent.$refs.presentimage; // Accessing the img tag inside the child component
			// image.classList.remove('zoom-fade'); // 移除动画类
			this.tabName = name;
			if (name === 'order_coucher') {
				return
			}
			if (name === "商品展示") {
				if (!this.userId) {
					this.wxLogin()
					return false;
				}
				this.getGoodsList();
			} else if (name == "在线报名") {
				// this.getApply();
			} else if (name == "邀请榜单") {
				this.getRankList(false);
			} else if (name == "互动评论") {
				// this.getUser();
			} else if (name == "内嵌链接") {
				const index = this.menuList.findIndex((item) => {
					return item.name == "内嵌链接";
				});
				const iframeSrc = this.menuList[index].url
				this.addIframe(iframeSrc);
				// this.jump(this.menuList[index].url);
			}
			if (name.includes('图文介绍')) {
				if (this.menuList.length === 0) {
					this.getMenu()
				}
			}
		},
		// 支付成功后重新刷新商品列表
		fetchGoodDetail() {
			this.getGoodsList()
		},
		addIframe(src){
			this.$nextTick(() => {
				const iframeContainer = document.getElementById('iframeContainer');
				if (!iframeContainer) return;
				iframeContainer.innerHTML = '';  // 清空容器
				const iframe = document.createElement('iframe');
				iframe.src = src;
				iframe.style.width = '100%';
				iframe.style.height = '100%';
				iframe.style.border = 'none';
				iframeContainer.appendChild(iframe);
			})
		},
		// 查看红包
		processRed(data) {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			console.log("processRed", data);
			this.redinfo = data;
			this.redpass = "";
			let datas = { user_id: this.userId, redpacket_id: this.redinfo.redpacket.id };
			api.checkRed(datas).then((res) => {
				if (res.code == 200) {
					console.log(res);
					if (res.result.status == 1) {
						// this.$router.push({
						// 	name: "reddetail",
						// 	query: { redId: this.redinfo.redpacket.id, liveId: this.id, userId: localStorage.getItem("userId") },
						// });
						// return;
						this.redDetail = res.result.desc;
						this.redDetail.user = res.result.user;
						this.recieveShow = true;
						return;
					}
					api.redDetail(datas).then((resb) => {
						console.log(resb, "detail");
						this.redinfo.redpacket = resb.result;
						console.log();
						this.redinfo.user = resb.result.user;
						this.redpacketShow = true;
					});
				}
			});
		},
		// 检查红包剩余个数
		checkRedremain(val) {
			const data = { redpacket_id: val };
			api.getRedremained(data).then((res) => {
				console.log("剩余红包", res.result);
				if (res.result.surplus_num == 0) {
					console.log("变化值前", this.redremainId);
					this.redremainId = val;
					console.log("变化值后", this.redremainId);
				}
			});
		},
		// 领取红包
		recieveRed() {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			const dataId = { redpacket_id: this.redinfo.redpacket.id };
			api.getRedremained(dataId).then((rest) => {
				console.log("剩余红包", rest.result);
				if (rest.result.surplus_num == 0) {
					if (this.redpacketShow == true && this.recieveShow == false) {
						this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">该红包已被领完</div>',
							type: "html",
						});
						this.redpacketShow = false;
					}
				} else {
					let pass = "";
					this.redDetail = {
						user: {},
						redpacket: {},
					};
					if (this.redinfo.redpacket.type == 2) {
						pass = this.redpass;
					}
					let data = { user_id: this.userId, live_id: this.id, redpacket_id: this.redinfo.redpacket.id, password: pass };
					api.redRecieve(data)
						.then((res) => {
							console.log(res, "redres");
							if (res.code == 200) {
								if (res.result.has_get == 2) {
									this.$toast({
										message:
											'<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">你已被该直播间拉黑</div>',
										type: "html",
									});
									return;
								}
								this.redDetail = res.result;
								this.redpacketShow = false;
								this.recieveShow = true;
							} else {
								this.$toast(res.message);
							}
						})
						.catch((resb) => {
							this.$toast(resb.message);
						});
				}
			});
		},
		// 点击右侧红包
		unopen() {
      if (!this.userId) {
        this.wxLogin()
        return false;
      }
			let data = { live_id: this.id, user_id: this.userId };
			api.unopenRed(data).then((res) => {
				console.log(res);
				if (res.result.num == 0) {
					this.$toast({
						message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">直播间暂时没有未开启红包</div>',
						type: "html",
					});
				} else {
					this.redinfo.redpacket = res.result.list[res.result.num - 1];
					let datas = { user_id: this.userId, redpacket_id: this.redinfo.redpacket.id };
					api.checkRed(datas).then((resb) => {
						if (resb.code == 200) {
							if (res.result == 1) {
								this.$router.push({
									name: "reddetail",
									query: { redId: this.redinfo.redpacket.id, liveId: this.id, userId: this.userId },
								});
								return;
							}
							const userdata = { user_id: this.redinfo.redpacket.user_id, live_id: this.id };
							api.getUserinfo(userdata).then((resd) => {
								console.log(resd, "red_use");
								this.redinfo.user = resd.result;
								this.redpass = "";
								this.redpacketShow = true;
							});
						}
					});
				}
			});
		},
		// onCopy() {
		// 	this.$toast("复制成功");
		// },
		// onError() {
		// 	this.$toast({
		// 		message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">复制失败</div>',
		// 		type: "html",
		// 	});
		// },
		up() {
			clearTimeout(this.time);
		},
		onSubmit() {},
		fnclosesign() {
			this.signShow = false;
			this.userinfo.sign_up = "1";
			// this.$router.go(0);
			window.location.reload();
			// 更新用户信息
			// this.getUserInfo()
		},
		jump(e) {
			window.location.href = e;
		},
		refreshPage() {
			window.location.reload();
		},
		// 红包
		openRed() {
			this.redShow = true;
			this.moreFunctionShow = false;
		},
		gethasToPAyCount(val) {
			this.hasToPAyCount = val
		},
		getOrderList() {
			console.log(345)
			const data = { user_id: this.userId, live_id: this.id };
			console.log('data,',data)
			api.myorders(data).then((res) => {
				console.log('我的订单列表', res);
				if (res.code === 200) {
					// 格式化订单时间（和子组件逻辑一致）
					this.orderList = res.result.map(item => ({
						...item,
						order_time: formatIsoToDateStart(item.order_time)
					}));
				} else {
					this.orderList = [];
				}
				// 更新是否有订单的标记（用于控制tab显示）
				this.hasOrderRecord = this.orderList && this.orderList.length > 0;
			});
		},
		getLicense() { // 查看营业执照
			this.showLicense = true
		},
		handleLicenseClose() { // 关闭营业执照
			this.showLicense = false
		},
		previewImage(urls, index) { // 查看大图
			if (!urls[index]) {
				return
			}
			ImagePreview({
				images: urls,
				startPosition: index,
				closeable: true,
				closeIcon: 'close',
				onClose() {

				}
			})
		},
		inviteAddressForm() {
			this.showInviteAddress = true
		},
		onConfirmAddress(values) {
			console.log('关闭区域===', values)
			this.invite_addres.area = values
					.filter((item) => !!item)
					.map((item) => item.name)
					.join("")
			this.area_show = false
		},
		closeAddress() {
			this.showInviteAddress = false
			this.inviteinfo = {
				link_name: '',
				link_phone: '',
				link_address: ""
			}
			this.invite_addres = {
				area: '',
				area_deatail: ''
			}
		},
		onSubmitAddress() { // 提交邀请榜获取收货地址
			if (this.inviteinfo.link_name == "") {
					this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写姓名</div>',
							type: "html",
					});
					return;
			}
			// if (this.inviteinfo.link_name != "" && !checkName(this.inviteinfo.link_name)) {
			// 		this.$toast({
			// 				message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写2-6位汉字姓名</div>',
			// 				type: "html",
			// 		});
			// 		return;
			// }
			if (this.inviteinfo.link_phone == "") {
					this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写手机号</div>',
							type: "html",
					});
					return;
			}
			if (this.inviteinfo.link_phone != "" && !checkMobile(this.inviteinfo.link_phone)) {
					this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写正确手机号</div>',
							type: "html",
					});
					return;
			}
			if (this.invite_addres.area == "") {
					this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请选择地区</div>',
							type: "html",
					});
					return;
			}
			if (this.invite_addres.area_deatail == "") {
					this.$toast({
							message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写详细地址</div>',
							type: "html",
					});
					return;
			}
			this.inviteinfo.live_id = this.id
      this.inviteinfo.user_id = this.userId
			this.inviteinfo.link_address = this.invite_addres.area + this.invite_addres.area_deatail
			console.log('邀请榜单地址提交', this.inviteinfo)
			api.inviteSendAddr(this.inviteinfo).then((res) => {
					if (res.code === 200) {
							this.$toast({
									message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">提交成功</div>',
									type: "html",
							})

							this.closeAddress()
							this.getRankList(false)
							
					} else {
							this.$toast(res.message);
					}
			});
		}
	}
}
</script>
<style lang="less" scoped>
@import "../assets/styles/homeindex.less";
@import "../assets/styles/dialogcommon.less";
.livercontent {
    padding: 0 16px;
    margin-top: 10px;
    border-bottom: 10px solid #f3f3f3;
}
#iframeContainer{
	height:100%;
}
.live-info{
	display: flex;
	align-items: center;
	justify-content: center;
	img{
		width: 18px;
		height: 18px;
		margin-right:6px;
	}
}
.van-field {
	width: 200px;
}
.pop-click{
	// display: none;
	line-height: 36px;
	padding-right: 12px;
	text-align: right;
	font-size: 15px;
	.click-btn{
		color: #1ab4ec;
	}
}
.sign-dialog{
	.tip{
		line-height: 36px;
		padding-top: 12px;
		color: #f44336;
	}
	.delButton{
		position: absolute;
		top: 16px;
		right: 16px;
		font-size: 24px;
	}
}
</style>
<style lang="less">
.van-cell__value {
	min-width: 70%;
}
::v-deep .van-field__control::-webkit-input-placeholder {
	color: #aaa;
}
.license_popup{
	padding-top: 24px;
	box-sizing: border-box;
	.preview-img{
		max-width: 100%;
		height: auto;
		cursor: zoom-in;
	}
	.imgs{
		text-align: center;
		img{
			margin-bottom: 16px;
			width: 48px;
			height: 48px;
			border-radius: 50%;
		}
	}
	h1{
		font-size: 18px;
		margin-bottom: 30px;
	}
	.infos{
		padding: 0 16px;
		text-align: left;
		p{
			font-size: 16px;
		}
		ul{
			margin-top: 24px;
			li{
				display: flex;
				margin-bottom: 16px;
				flex-wrap: wrap;
				span{
					display: inline-block;
					width: 60px;
					color: #666;
				}
				img{
					width: 100%;
					object-fit: fill;
					margin-top: 12px;
				}
			}
		}
		small{
			margin-top: 40px;
			font-size: 12px;
			color: #999;
			display: block;
		}
	}
}
</style>
